import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { MapPin, MessageCircle, Calendar, Camera, User } from 'lucide-react';

const BottomNav = () => {
  const location = useLocation();
  const { t } = useLanguage();

  const navItems = [
    { path: '/map', icon: MapPin, label: t('map') },
    { path: '/discovery', icon: MapPin, label: t('discover') },
    { path: '/chat', icon: MessageCircle, label: t('chat') },
    { path: '/events', icon: Calendar, label: t('events') },
    { path: '/checkins', icon: Camera, label: t('checkins') },
    { path: '/profile', icon: User, label: t('profile') }
  ];

  return (
    <div className="bottom-nav">
      <div className="nav-items">
        {navItems.map(({ path, icon: Icon, label }) => (
          <Link
            key={path}
            to={path}
            className={`nav-item ${location.pathname === path ? 'active' : ''}`}
          >
            <Icon size={20} />
            <span className="nav-label">{label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BottomNav;